import {
    UPDATE_LANGUAGE_CODE,
} from '../../actionTypes';

export const updateTranslationSetting = (code) => {
    return {
        type: UPDATE_LANGUAGE_CODE,
        payload: code
    };
}